import { listAdCampaigns, type AdCampaignSummary } from '../../acquisition/api/casino-ad-service';
import { useAffiliateResource, type AffiliateResource } from './useAffiliateResource';

export type LumioCampaignsResource = AffiliateResource<AdCampaignSummary[]>;

/**
 * Stable module-level fetcher (`useAffiliateResource` requires one). The key it receives is
 * the brand's `tenant_id` (the Ad Service scope), NOT the `casino_instance_id` the affiliate
 * calls use. No caller `AbortSignal` is passed: the Ad Service client shares one in-flight
 * request across callers and `useAffiliateResource` already drops stale responses.
 * `pageSize: 100` is the API maximum, matching the acquisition browser.
 */
const fetchLumioCampaigns = (tenantId: string): Promise<AdCampaignSummary[]> =>
  listAdCampaigns({ tenantId, pageSize: 100 }).then((list) => list.campaigns);

/** The brand's acquisition (Lumio) campaigns, keyed by `tenant_id`. Read-only; best-effort. */
export function useLumioCampaigns(tenantId: string | undefined): LumioCampaignsResource {
  return useAffiliateResource(tenantId, fetchLumioCampaigns);
}
